import React, { useState, useRef, useEffect } from "react";
import axiosSmartSurvey from "../../api/axios";
import {
  Box, Button, Stack, Card, CardContent, Typography, TextField,
  Snackbar, Alert, Dialog, DialogActions, DialogContent, DialogTitle,
  Grid, MenuItem
} from '@mui/material';
import useTrackDoc from "./hooks/useTrackDoc";
import moment from 'moment';
import 'moment/locale/th';
// 🟢 ImportConstants มาใช้งาน
import { PARCEL_TYPE_OPTIONS, getParcelTypeName } from "../../constants/parcelConstants";

const TrackDocSearch = () => {
  const [code, setCode] = useState("");
  const [doc, setDoc] = useState(null);
  const inputRef = useRef(null);

  const [openError, setOpenError] = useState(false);
  const [errorText, setErrorText] = useState('');
  const [openSuccess, setOpenSuccess] = useState(false);
  const [successText, setSuccessText] = useState('');

  const [openEditModal, setOpenEditModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [editForm, setEditForm] = useState({
    parcelCode: "",
    oldParcel: "",
    dn: "",
    parcelType: ""
  });

  const { fetchSingleFolderData } = useTrackDoc();

  const handleSearch = async (e) => {
    if (e) e.preventDefault();
    if (!code.trim()) return;

    await fetchSingleFolderData(code, setDoc, setOpenError, setErrorText);
    setCode("");
    if (inputRef.current) inputRef.current.focus();
  };

  const handleOpenEdit = () => {
    if (!doc) return;
    setEditForm({
      parcelCode: doc.parcelCode || "",
      oldParcel: doc.oldParcel || "",
      dn: doc.dn || "",
      parcelType: doc.parcelType || doc.parcelTypeName || "โฉนด"
    });
    setOpenEditModal(true);
  };

  const handleSaveEdit = async () => {
    try {
      setIsSubmitting(true);
      const response = await axiosSmartSurvey.post('/trackdoc/update-land-info', editForm);

      if (response.data?.status === 'OK') {
        setDoc(prev => ({
          ...prev,
          parcelCode: editForm.parcelCode,
          oldParcel: editForm.oldParcel,
          dn: editForm.dn,
          parcelTypeName: editForm.parcelType,
          parcelType: editForm.parcelType
        }));

        setSuccessText("แก้ไขข้อมูลแฟ้มเอกสารสำเร็จเรียบร้อยแล้ว");
        setOpenSuccess(true);
        setOpenEditModal(false);
      } else {
        setErrorText(response.data?.message || "บันทึกข้อมูลไม่สำเร็จ");
        setOpenError(true);
      }
    } catch (err) {
      console.error("Update Folder Data Error:", err);
      setErrorText("เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์");
      setOpenError(true);
    } finally {
      setIsSubmitting(false);
      if (inputRef.current) inputRef.current.focus();
    }
  };

  useEffect(() => {
    if (inputRef.current) inputRef.current.focus();
  }, []);

  useEffect(() => {
    console.log(doc)
  }, [doc])


  return (
    <Box className='otherSide' id="otherSide" sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box className='surveyLayouts' id="surveyLayouts"></Box>

      <Snackbar open={openError} autoHideDuration={3000} onClose={() => setOpenError(false)} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert variant="filled" severity="error" sx={{ width: '100%' }}>{errorText}</Alert>
      </Snackbar>

      <Snackbar open={openSuccess} autoHideDuration={3000} onClose={() => setOpenSuccess(false)} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert variant="filled" severity="success" sx={{ width: '100%' }}>{successText}</Alert>
      </Snackbar>

      <Card sx={{ border: '1px solid #e0e0e0', background: '#fafaeb', m: 2, width: { xs: '95%', md: '60%' } }}>
        <CardContent>
          <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: 'bold' }}>
            ค้นหาซองเอกสารที่ดิน
          </Typography>
        </CardContent>

        <CardContent>
          <Box mb={2} component="form" onSubmit={handleSearch} align="center">
            <TextField
              inputRef={inputRef}
              label="ยิงบาร์โค้ด หรือพิมพ์รหัสแปลง (เช่น 01A001/001)"
              value={code}
              sx={{ width: { xs: '100%', sm: '320px' } }}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
              variant="outlined"
            />
            <Button variant="contained" color="primary" type="submit" sx={{ ml: { sm: 1 }, mt: { xs: 1, sm: 0 }, fontSize: '1.1rem', py: 1.5 }}>
              🔍 ค้นหา
            </Button>
          </Box>
        </CardContent>

        {doc && (
          <>
            <CardContent sx={{ px: { xs: 2, sm: 4 } }}>
              <Typography variant="h6" gutterBottom color="primary" sx={{ borderBottom: '2px solid #025464', pb: 0.5 }}>
                📄 ข้อมูลซองเอกสาร
              </Typography>
              <Stack spacing={1.5} sx={{ mt: 2 }}>
                <Typography>
                  <strong>รหัสแปลงที่ดินใหม่ :</strong> {doc.parcelCode || "-"}
                </Typography>

                <Typography>
                  <strong>รหัสแปลงที่ดินเก่า :</strong> {doc.oldParcel || "-"}
                </Typography>

                <Typography>
                  <strong>เลขเอกสารสิทธิ์ที่ดิน :</strong> {doc.dn || "-"}
                </Typography>

                <Typography>
                  <strong>ประเภทเอกสารสิทธิ์ :</strong> {getParcelTypeName(doc.parcelType)}
                </Typography>

                <Typography>
                  <strong>ชื่อผู้ถือซอง :</strong> {
                    doc.holder == 0 || !doc.holder
                      ? 'ห้องซอง'
                      : `${doc.fname || ''} ${doc.lname || ''}`.trim() || "-"
                  }
                </Typography>

                <Typography>
                  <strong>ตั้งแต่วันที่ :</strong> {
                    doc.recievedDate
                      ? moment(doc.recievedDate).add(543, 'year').format('DD MMMM YYYY เวลา HH:mm:ss')
                      : "-"
                  }
                </Typography>
              </Stack>
            </CardContent>

            <CardContent align="center" sx={{ pb: 3 }}>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
                <Button variant="contained" color="warning" onClick={handleOpenEdit} sx={{ fontSize: '1.1rem', py: 1.2, px: 3 }}>
                  📝 แก้ไขข้อมูล
                </Button>
                <Button variant="contained" color="secondary" onClick={() => {
                  window.open(`/trackdoc/print?parcelCode=${encodeURIComponent(doc.parcelCode)}&oldParcel=${encodeURIComponent(doc.oldParcel || '')}`, '_blank');
                  if (inputRef.current) inputRef.current.focus();
                }} sx={{ fontSize: '1.1rem', py: 1.2, px: 3 }}>
                  🖨️ พิมพ์บาร์โค้ด
                </Button>
              </Stack>
            </CardContent>
          </>
        )}
      </Card>

      {/* 🟢 Dialog สำหรับแก้ไขข้อมูลซองเอกสารที่ดิน (ครอบด้วย <form>) */}
      <Dialog
        open={openEditModal}
        onClose={() => setOpenEditModal(false)}
        fullWidth
        maxWidth="sm"
      >
        {/* 🔑 แท็ก <form> ครอบตั้งแต่นี่ ยันจบ DialogActions */}
        <form onSubmit={(e) => {
          e.preventDefault(); // ป้องกันการ Refresh หน้าเว็บ
          handleSaveEdit();   // เรียกฟังก์ชันบันทึกข้อมูล
        }}>
          <DialogTitle sx={{ fontWeight: 'bold', borderBottom: '1px solid #e0e0e0' }}>
            📝 แก้ไขข้อมูลซองเอกสารที่ดิน (folder_data)
          </DialogTitle>

          <DialogContent dividers>
            <Grid container spacing={2} sx={{ mt: 0.5 }}>
              {/* 1. parcel_code (Disabled) */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  disabled
                  label="รหัสแปลงที่ดินใหม่ (parcel_code)"
                  value={editForm.parcelCode}
                  helperText="คีย์หลักอ้างอิงของตาราง"
                />
              </Grid>

              {/* 2. old_parcel */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="รหัสแปลงที่ดินเก่า (old_parcel)"
                  value={editForm.oldParcel}
                  onChange={(e) => setEditForm({ ...editForm, oldParcel: e.target.value.toUpperCase() })}
                />
              </Grid>

              {/* 3. dn */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="เลขเอกสารสิทธิ์ (dn)"
                  value={editForm.dn}
                  onChange={(e) => setEditForm({ ...editForm, dn: e.target.value })}
                />
              </Grid>

              {/* 4. parcel_type */}
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  fullWidth
                  label="ประเภทเอกสารสิทธิ์ (parcel_type)"
                  value={String(editForm.parcelType || '1')}
                  onChange={(e) => setEditForm({ ...editForm, parcelType: e.target.value })}
                >
                  {PARCEL_TYPE_OPTIONS.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions sx={{ p: 2 }}>
            <Button onClick={() => setOpenEditModal(false)} color="inherit">
              ยกเลิก
            </Button>

            {/* 🔑 ปุ่มบันทึกใส่ type="submit" เพื่อรองรับทั้งการคลิกและการกด Enter */}
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'กำลังบันทึก...' : '💾 บันทึกข้อมูล'}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </Box>
  );
};

export default TrackDocSearch;